import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cart: {
    data: [],
    loading: false,
    error: null,
  },
};

export const cartSlice = createSlice({
  name: "cartInfo",
  initialState,
  reducers: {
    addToCart: (state, { payload }) => {
      const existing = state.cart.data.find(
        (item) =>
          item.id === payload.id && item.selectedSize === payload.selectedSize
      );

      if (existing) {
        existing.quantity += payload.quantity;
      } else {
        state.cart.data.push({ ...payload });
      }
    },
    removeFromCart: (state, action) => {
      const { id, selectedSize } = action.payload;
      state.cart.data = state.cart.data.filter(
        (item) => !(item.id === id && item.selectedSize === selectedSize)
      );
    },
    clearCart: (state) => {
      state.cart.data = [];
    },
    incrementQuantity: (state, action) => {
      const { id, selectedSize } = action.payload;
      const item = state.cart.data.find(
        (i) => i.id === id && i.selectedSize === selectedSize
      );
      if (item) item.quantity += 1;
    },

    decrementQuantity: (state, action) => {
      const { id, selectedSize } = action.payload;
      const item = state.cart.data.find(
        (i) => i.id === id && i.selectedSize === selectedSize
      );
      if (item && item.quantity > 1) item.quantity -= 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("logout", () => ({ ...initialState, loggedIn: false }));
  },
});

export const {
  addToCart,
  removeFromCart,
  clearCart,
  incrementQuantity,
  decrementQuantity,
} = cartSlice.actions;

export const selectCart = (state) => state.cartInfo.cart;

export default cartSlice.reducer;
